import Keycloak from "keycloak-js";
import { getConfig } from "./config";

export const configToUse = getConfig(import.meta.env.VITE_APP_SCENARIO);

const keycloak = new Keycloak({
  url: configToUse.VITE_APP_KEYCLOAK_URL,
  realm: configToUse.VITE_APP_KEYCLOAK_REALM,
  clientId: configToUse.VITE_APP_KEYCLOAK_REALM_CLIENT_ID,
  "enable-cors": true,
});

export default keycloak;
